import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  Alert,
  ThemeProvider,
} from '@mui/material';
import { themeDevelopment, themeProduction } from '../theme';
import { useEnvironment } from '../context/EnvironmentContext';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { isDevelopment } = useEnvironment();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      if (username === process.env.REACT_APP_USER_NAME && password === process.env.REACT_APP_USER_PASSWORD) {
        onLogin(process.env.REACT_APP_TOKEN);
      } else {
        setError('Invalid credentials');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    }
  };

  return (
    <ThemeProvider theme={isDevelopment ? themeDevelopment : themeProduction}>
      <Container component="main" maxWidth="xs">
        <Paper elevation={6}>
          <Typography component="h1" variant="h4" sx={{ mb: 3 }}>
            Welcome
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                },
              }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                },
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
            >
              Sign In
            </Button>
          </form>
          {error && (
            <Alert severity="error" sx={{ mb: 2, mt: 2 }}>
              {error}
            </Alert>
          )}
        </Paper>
      </Container>
    </ThemeProvider>
  );
}

export default Login; 